// --- GSAP等の設定 ----
// GSAP
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
// import { CustomEase } from "gsap/CustomEase.js"; // カスタムイージング作成が必要なときは使用

gsap.registerPlugin(ScrollTrigger);



// --- section switch  ---
document.addEventListener('DOMContentLoaded', function(event) {

  // [初期値] => Fixed
  if (document.querySelector('.js-fixed-switch-wrapper .js-fixed-switch')) {
    let arrayST = [];
      
    // 高さ設定
    window.addEventListener('load', init);
    window.addEventListener('resize', init);
    function init(e) {
      setPb();
      setWrapperHeight();
      if (arrayST.length > 0) {
        killST();
      }
      setST();
    }
    function setWrapperHeight() {
      document.querySelectorAll('.js-fixed-switch-wrapper').forEach(wrapper => {
        wrapper.style.height = `${wrapper.clientHeight}px`;
      })
    }
    function setPb() {
      if (document.querySelector('.js-pb-set .js-pb-set-content')) {
        const wrapper = document.querySelector('.js-pb-set');
        const content = wrapper.querySelector('.js-pb-set-content');
        const pb = Math.floor((window.innerHeight - content.clientHeight) / 2);
        wrapper.style.paddingBottom = `${pb}px`;
      }
    }
    function setST() {
      document.querySelectorAll('.js-fixed-switch-wrapper .js-fixed-switch').forEach(target => {
        try {
          const wrapper = target.closest('.js-fixed-switch-wrapper');
          if (!wrapper) {
            throw new Error('Fixedへ切替処理の親要素 .js-fixed-switch-wrapper がありません');
          }
          const st = ScrollTrigger.create({
            toggleActions: 'play pause resume reset',
            trigger: wrapper,
            start: `bottom bottom`,
            scrub: true,
            onEnter: function() {
              target.classList.add('--fixed');
            },
            onLeaveBack: function() {
              target.classList.remove('--fixed');
            },
          });
        } catch(err) {
          console.error(err);
        }
      });
    }
    function killST() {
      for(let st of arrayST) {
        st.kill();
      }
      arrayST = [];
    }
    
    

  }


});

